import React from 'react';
import Home from './home/async';
import Post from './post/async';
import Author from './author/async';
import Search from './search/async';
import {Navigate, Route} from 'react-router-dom';

export default [
  <Route
    key="/business/blog/author/:name"
    path="business/blog/author/:name"
    element={<Author />}
  />,
  <Route
    key="/business/blog/post"
    path="business/blog/post"
    element={<Post />}
  />,
  <Route
    key="/business/blog/author"
    path="business/blog/author"
    element={<Author />}
  />,
  <Route
    key="/business/blog/search"
    path="business/blog/search/:keywords"
    element={<Search />}
  />,
  <Route
    key="/business/blog/category/:attr"
    path="business/blog/category/:attr"
    element={<Search />}
  />,
  <Route
    key="/business/blog/:category/:title"
    path="business/blog/:category/:title"
    element={<Post />}
  />,
  <Route
    key="/business/blog/:param"
    path="business/blog/:param"
    element={<Home />}
  />,
  <Route
    key="/business/blog"
    path="business/blog"
    element={<Navigate to="1" replace />}
  />,
];
